/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { MessageRole } from "./MessageRole";
export const MessageApiCreateData = core.serialization.object({
    messageId: core.serialization.string().optional(),
    content: core.serialization.record(core.serialization.string(), core.serialization.any()),
    parts: core.serialization
        .list(core.serialization.record(core.serialization.string(), core.serialization.any()))
        .optional(),
    annotations: core.serialization
        .list(core.serialization.record(core.serialization.string(), core.serialization.any()))
        .optional(),
    role: MessageRole,
    state: core.serialization.record(core.serialization.string(), core.serialization.any()).optional(),
    metadata: core.serialization.record(core.serialization.string(), core.serialization.any()).optional(),
});
